export default class DemographicPromptResponseModel {
    constructor(){}

    demographicPromptResponseId : number
    personKey? : number
    primaryActionTaken? : boolean
    permanentlyDismiss? : boolean
}

